export default __webpack_public_path__ + "static/icon-light-2730631a56f57dadb83f4b7dc07428df.png";